export const formatDate = (dateToFormat: string): string | React.ReactNode => {
  if (dateToFormat === null) return '-';
  const date = new Date(dateToFormat);
  return String(date) !== 'Invalid Date' ? <div>{date.toLocaleDateString('pt-BR')}</div> : '-';
};
